/* Utils */
import { generateEntityActionTypes } from '../utils/generators/actionTypeGenerators';

const ENTITY_NAME = 'CONTENTS';

export const FETCH_CONTENT_BY_ID = `${ENTITY_NAME}/FETCH/BY_ID`;
export const FETCH_VOD_CONTENT_PROGRESS = `${ENTITY_NAME}/FETCH/PROGRESS`;
export const FETCH_VOD_CONTENT_MOVIE_PROGRESS = `${ENTITY_NAME}/MOVIE/FETCH/PROGRESS`;
export const UPDATE_CONTENT_PROGRESS = `${ENTITY_NAME}/UPDATE/PROGRESS`;
export const CONTENT_ENTITY_ACTION_TYPES = generateEntityActionTypes(ENTITY_NAME);
